"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _xcx = require("@/api/xcx");
var _compForm = _interopRequireDefault(require("./components/compForm"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    compForm: _compForm.default
  },
  data: function data() {
    return {
      id: 0,
      activeNum: 1,
      configData: (0, _defineProperty2.default)({
        first_level: {
          goods: [],
          main_title: ''
        },
        second_level: {
          goods: [],
          main_title: ''
        },
        third_level: {
          goods: [],
          main_title: ''
        }
      }, "third_level", {
        goods: [],
        main_title: ''
      }),
      pageType: 'default',
      compFormData: {},
      imgWidth: 750,
      imgHeight: 320
    };
  },
  computed: {
    sectionList: function sectionList() {
      var sectionList = [];
      switch (this.pageType) {
        default:
          sectionList = [{
            title: "商品（2）推荐位",
            key: 'first_level',
            imgName: '10.jpg',
            num: 2
          }, {
            title: "商品（9）推荐位",
            key: 'second_level',
            imgName: '3.jpg',
            num: 9
          }, {
            title: "商品（2）推荐位",
            key: 'third_level',
            imgName: '10.jpg',
            num: 2
          }, {
            title: "商品（9）推荐位",
            key: 'fourth_level',
            imgName: '3.jpg',
            num: 9
          }];
          break;
      }
      return sectionList;
    },
    pageTitle: function pageTitle() {
      var title = this.configData.first_level.main_title ? this.configData.first_level.main_title : '';
      return title;
    }
  },
  watch: {
    activeNum: function activeNum(val) {
      if (val) {
        this.setData(val);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      // console.log('this.$route', this.$route)
      this.id = this.$route.params.id;
      if (this.id > 0) {
        this.$route.meta.title = '编辑 - 活动页';
        this.getData();
      } else {
        this.$route.meta.title = '添加 - 活动页';
      }
    },
    getData: function getData() {
      var _this = this;
      (0, _xcx.getEventInfo)(this.id).then(function (result) {
        var data = result && result.details ? JSON.parse(result.details) : false;
        console.log('getEventInfo', data);
        _this.setConfigData(data);
        _this.setData(_this.activeNum);
      });
    },
    setData: function setData(pos) {
      var key = this.sectionList[pos - 1].key;
      var data = (0, _objectSpread2.default)({}, this.configData[key]);
      data.goods = data.goods ? data.goods : [];
      if (data.goods.length > 0) {
        data.goods.forEach(function (item) {
          item.id = item.id ? item.id : item.goods_id;
          item.goods_id = item.goods_id ? item.goods_id : item.id;
        });
      }
      this.compFormData = data;
      // this.$nextTick(() => {
      // 	this.$refs.compForm.formData = data;
      // })
    },
    setConfigData: function setConfigData() {
      var _this2 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.sectionList.forEach(function (item, index) {
        var key = 'first_level';
        switch (index + 1) {
          case 1:
            key = 'first_level';
            break;
          case 2:
            key = 'second_level';
            break;
          case 3:
            key = 'third_level';
            break;
          case 4:
            key = 'fourth_level';
            break;
        }
        _this2.configData[key] = data && data[key] ? data[key] : {
          goods: [],
          main_title: ''
        };
      });
    },
    // 保存
    save: function save() {
      var _this3 = this;
      var params = this.$refs.compForm.getSubmitData();
      console.log('save', params);
      if (params) {
        (0, _xcx.editEventPage)((0, _objectSpread2.default)({
          id: this.id,
          page_title: this.pageTitle
        }, params)).then(function (res) {
          if (_this3.id == 0) {
            _this3.id = res;
          }
          _this3.getData();
        });
      }
    },
    // 发布
    submit: function submit() {
      (0, _xcx.releaseEventPage)(this.id).then(function (res) {});
    }
  }
};
exports.default = _default;